import * as React from 'react';
import { CalendarX, MessageSquarePlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
export const CampaignNotFound = () => {
    const { t } = useTranslation();
    const { publicId } = useParams({ from: '/console/_authenticated/_layout/campaigns/$publicId/_layout' });
    return (<div className="w-full h-full flex flex-col justify-center items-center gap-4">
            <CalendarX className="w-32 h-32 mb-4 text-primary"/>
            <p className="text-xl text-primary font-bold">
                {t('campaigns.not_found.title', { ns: 'glossary', publicId })}
            </p>
            <span className="text-md text-muted-foreground">
                {t('campaigns.not_found.description', { ns: 'glossary', publicId })}
            </span>
            <Button asChild>
                <Link to="/console/campaigns/new">
                    <MessageSquarePlus />
                    {t('campaigns.not_found.button', { ns: 'glossary' })}
                </Link>
            </Button>
        </div>);
};
